<template>
  <el-dropdown @command="handleCommandRoute" >
    <span class="el-dropdown-route" style="display: flex;align-items: center">切换线路<i style="font-size: 14px" class="fa fa-globe"></i><i style="margin-left: 2px" class="el-icon-arrow-down el-icon--right"></i></span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :class="getRouteClass(ipInfo.mainIp)" command="main">主线路
      </el-dropdown-item>
      <el-dropdown-item :class="getRouteClass(ipInfo.liantongIp)" command="liantong">联通专线
      </el-dropdown-item>
      <el-dropdown-item :class="getRouteClass(ipInfo.dianxinIp)" command="dianxin">电信专线</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.min.css';
export default {
  name: "LEDropDownRoute",
  props:{
    preWebFix:{
      default:""
    },
    ipInfo:{
      default: ()=>({
        mainIp:"",
        liantongIp:"",
        dianxinIp:"",
      })
    }
  },
  data(){
    return{
    }
  },
  computed: {
    currentIp(){
      return window.location.origin
    }
  },
  methods:{
    getRouteClass(ip) {
      if(ip){
        if (this.currentIp.includes("www")) {
          return this.currentIp.includes(ip) ? 'currentRoute' : ''
        } else {
          return this.currentIp.includes(ip.replace('www.', '')) ? 'currentRoute' : ''
        }
      }else {
        return ''
      }

    },
    async handleCommandRoute(command) {
      const params = new URLSearchParams(window.location.search);
      let path=window.location.pathname
      params.set('isNeedRush', 'true')
      params.set('token', localStorage.getItem('delivery_token'))
      const qs = new URLSearchParams(params).toString();
      let fullPath=`${path}${qs ? '?' + qs : ''}`
      document.getElementById('app').style.display="none"
      let web=this.preWebFix
      let domainName = ""
      switch (command) {
        case 'liantong':
          domainName = this.currentIp.includes("www") ? this.ipInfo.liantongIp : this.ipInfo.liantongIp.replace("www.", "")
          window.open(`${domainName}${web}${fullPath}`, '_self')
          break;
        case 'dianxin':
          domainName = this.currentIp.includes("www") ? this.ipInfo.dianxinIp : this.ipInfo.dianxinIp.replace("www.", "")
          window.open(`${domainName}${web}${fullPath}`, '_self');
          break;
        case 'main':
          domainName = this.currentIp.includes("www") ? this.ipInfo.mainIp : this.ipInfo.mainIp.replace("www.", "")
          window.open(`${domainName}${web}${fullPath}`, '_self');
          break;
      }
    }
  }
}
</script>



<style scoped>
.el-dropdown-route {
  cursor: pointer;
  color: #43b981;
  font-size: 15px;
}
.el-dropdown-route:hover {
  color: #2975e3;
}
.currentRoute {
  background-color: #5ebfc8;
  color: white;
}

</style>
